module.exports = __webpack_public_path__ + "static/media/CircleRoundTable.0394b948.png";